import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import React, { useState } from "react";
export default function usePesProductDataInit() {
    var _useState = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 1400,
        height: 650,
        pin: false,
        mode: "normal",
        modalname: "pes-product-select"
    }), 2), modal = _useState[0], setModal = _useState[1];
    var _useState1 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 530,
        height: 450,
        pin: false,
        mode: "normal",
        modalname: "pes-product-sort"
    }), 2), modalSort = _useState1[0], setModalSort = _useState1[1];
    var _useState2 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 530,
        height: 570,
        pin: false,
        mode: "normal",
        modalname: "pes-product-display"
    }), 2), modalDisplayColumn = _useState2[0], setModalDisplayColumn = _useState2[1];
    var _useState3 = _sliced_to_array(useState(null), 2), documentType = _useState3[0], setDocumentType = _useState3[1];
    var _useState4 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 1400,
        height: 700,
        pin: false,
        mode: "normal",
        modalname: "pes-select-document"
    }), 2), modalSelectDocument = _useState4[0], setModalSelectDocument = _useState4[1];
    var _useState5 = _sliced_to_array(useState({
        barcode: false,
        supplierCode: false,
        productsOrdered: false,
        ums: false,
        vat: false,
        valueIncludingTax: false
    }), 2), columdisplay = _useState5[0], setColumDisplay = _useState5[1];
    var _useState6 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 530,
        height: 570,
        pin: false,
        mode: "normal",
        modalname: "pes-product-filter"
    }), 2), modalDisplayFilter = _useState6[0], setModalDisplayFilter = _useState6[1];
    return {
        modal: modal,
        setModal: setModal,
        modalSort: modalSort,
        setModalSort: setModalSort,
        modalDisplayColumn: modalDisplayColumn,
        setModalDisplayColumn: setModalDisplayColumn,
        documentType: documentType,
        setDocumentType: setDocumentType,
        modalSelectDocument: modalSelectDocument,
        setModalSelectDocument: setModalSelectDocument,
        columdisplay: columdisplay,
        setColumDisplay: setColumDisplay,
        modalDisplayFilter: modalDisplayFilter,
        setModalDisplayFilter: setModalDisplayFilter
    };
}
